import { AxiosResponse } from "axios";
import http from "@/http-common";

export interface DateRange {
  completeTo: number;
  maxYear: number;
  minYear: number;
}

class ConfigDataService {
  getDateRange(): Promise<AxiosResponse<DateRange>> {
    return http.get<DateRange>("/config/date-range");
  }
}

export default new ConfigDataService();
